import Overview from './components/overview/Overview.vue';
import Device from './components/device/Device.vue';
import Views from './components/views/Views.vue';

const routes = [{
        path: '/',
        component: Overview
    },
    {
        path: '/view/:viewid',
        component: Overview
    },
    {
        path: '/views',
        component: Views
    },
    {
        path: '/device/:uuid',
        component: Device
    },
];

export default routes;